// First Available Date Calculator for Shopify
(function() {
  'use strict';
  
  function getFirstAvailableDate() {
    const now = new Date();
    const currentHour = now.getHours();
    const isAM = currentHour < 12;
    const currentDay = now.getDay();
    const minDateObj = new Date();

    if (currentDay === 4) { // Thursday
      if (isAM) {
        minDateObj.setDate(minDateObj.getDate() + 1);
      } else {
        minDateObj.setDate(minDateObj.getDate() + 4);
      }
    } else if (currentDay === 5) { // Friday
      if (isAM) {
        minDateObj.setDate(minDateObj.getDate() + 3);
      } else {
        minDateObj.setDate(minDateObj.getDate() + 4);
      }
    } else if (currentDay === 6) { // Saturday
      minDateObj.setDate(minDateObj.getDate() + 3);
    } else if (currentDay === 0) { // Sunday
      minDateObj.setDate(minDateObj.getDate() + 2);
    } else { // Monday-Wednesday
      if (isAM) {
        minDateObj.setDate(minDateObj.getDate() + 1);
      } else {
        minDateObj.setDate(minDateObj.getDate() + 2);
      }
    }

    return minDateObj.toISOString().split('T')[0];
  }

  // Update cart with first available date
  async function updateCartWithFirstAvailableDate() {
    try {
      const firstAvailableDate = getFirstAvailableDate();
      
      const response = await fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          attributes: {
            'Delivery-Date': firstAvailableDate
          }
        })
      });
    } catch (error) {
      console.error('Error updating cart:', error);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', updateCartWithFirstAvailableDate);
  } else {
    updateCartWithFirstAvailableDate();
  }
})();
